import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import AppStartup from './containers/AppStartup';
import keycloak from './auth/keycloak';
import AuthProvider from './auth/AuthProvider';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';

import theme from './theme/theme';
import './theme/fonts/stylesheet.css';
import { store } from 'createStore';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { enableMapSet } from 'immer';
import { initializeNetworkMonitoring } from './util/initializeNetworkMonitoring';
import { TokenRefreshMonitor } from './auth/TokenRefreshMonitor';
import { SessionRecoveryBanner } from './auth/SessionRecoveryBanner';

enableMapSet();

initializeNetworkMonitoring();

const RehydratedApp = () => {
  return (
    <AuthProvider keycloak={keycloak}>
      <Provider store={store}>
        <TokenRefreshMonitor />
        <ThemeProvider theme={theme}>
          <StyledEngineProvider injectFirst>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <SessionRecoveryBanner />
              <AppStartup>
                <App />
              </AppStartup>
            </LocalizationProvider>
          </StyledEngineProvider>
        </ThemeProvider>
      </Provider>
    </AuthProvider>
  );
};

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <RehydratedApp />
  </React.StrictMode>,
);
